import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { NumberField } from "features/WorklistTools/shared/components/NumberField";
import styled from "styled-components";

interface AliquotSettingsProps {
  numberOfAliquots: number;
  aliquotVolume: number;
  incubationTime: number;
  handleMethodSettingsChanged: (key: string, value: any) => void;
}

const StyledAliquotSettings = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 5px;
`;

export const AliquotSettings = ({
  numberOfAliquots,
  aliquotVolume,
  incubationTime,
  handleMethodSettingsChanged,
}: AliquotSettingsProps) => {
  const numAliquotsErr = numberOfAliquots < 1 || numberOfAliquots > 3;
  const aliquotVolErr = aliquotVolume === 0;
  const incubationErr = incubationTime < 5 || incubationTime > 60;
  const anyError = numAliquotsErr || aliquotVolErr || incubationErr;

  const errorTextHeight = 3;

  return (
    <StyledAliquotSettings>
      <NumberField
        style={{
          flexGrow: 1,
          marginBottom: anyError && !numAliquotsErr ? errorTextHeight : 0,
        }}
        size={"small"}
        id="number-of-aliquots"
        label="# Dead Tot Aliquots"
        value={numberOfAliquots}
        minValue={1}
        maxValue={3}
        onChange={(value) =>
          handleMethodSettingsChanged("numberOfAliquots", value)
        }
      />
      <FormControl
        sx={{
          flexGrow: 1,
          marginBottom: anyError && !aliquotVolErr ? errorTextHeight : 0,
        }}
        variant="outlined"
        error={aliquotVolume === 0}
        size="small"
      >
        <InputLabel id="aliquot-vol-label">Dead Total Aliquot Vol</InputLabel>
        <Select
          labelId="aliquot-vol-label"
          id="aliquot-vol-select"
          value={aliquotVolume}
          label="Dead Tot Aliquot Vol --"
          size="small"
          onChange={(e) =>
            handleMethodSettingsChanged("aliquotVolume", e.target.value)
          }
        >
          <MenuItem value={0}>0 (µL)</MenuItem>
          <MenuItem value={5}>5 (µL)</MenuItem>
          <MenuItem value={10}>10 (µL)</MenuItem>
          <MenuItem value={15}>15 (µL)</MenuItem>
          <MenuItem value={20}>20 (µL)</MenuItem>
          <MenuItem value={25}>25 (µL)</MenuItem>
        </Select>
        {aliquotVolume === 0 && (
          <FormHelperText>Invalid Aliquot Volume</FormHelperText>
        )}
      </FormControl>
      <NumberField
        style={{
          flexGrow: 1,
          marginBottom: anyError && !incubationErr ? errorTextHeight : 0,
        }}
        size={"small"}
        id="incubation-time"
        label="Incubation Time (Mins)"
        value={incubationTime}
        minValue={5}
        maxValue={60}
        onChange={(value) =>
          handleMethodSettingsChanged("incubationTime", value)
        }
      />
    </StyledAliquotSettings>
  );
};
